"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Template3FaqItem = void 0;

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

require("./template-3-faq-item.scss");

var play_svg_1 = __importDefault(require("./play.svg"));

function Template3FaqItem(_a) {
  var title = _a.title,
      content = _a.content,
      active = _a.active,
      handleState = _a.handleState,
      index = _a.index,
      borderTop = _a.borderTop,
      className = _a.className,
      props = __rest(_a, ["title", "content", "active", "handleState", "index", "borderTop", "className"]);

  return react_1.default.createElement("div", {
    className: "faq-item w-full overflow-hidden ".concat(borderTop && "border-t")
  }, react_1.default.createElement("div", Object.assign({
    className: "faq-item-heading flex",
    onClick: function onClick() {
      return handleState(index, !active);
    }
  }, props), react_1.default.createElement("label", {
    className: "block px-0 py-3 md-1:p-5 leading-normal cursor-pointer text-sm md-1:faq-item-title font-semibold ".concat(className === null || className === void 0 ? void 0 : className.title)
  }, title), react_1.default.createElement("div", {
    className: "toogle-active px-0 py-3 md-1:p-5 flex flex-1"
  }, react_1.default.createElement("div", {
    className: "bg-faq-item relative bg-faq-item-template-3 cursor-pointer ml-auto"
  }, react_1.default.createElement("img", {
    className: "faq-item-template-3-heading-icon ".concat(!active ? 'faq-icon-display' : 'faq-icon-hidden', " ").concat(className.icon),
    src: play_svg_1.default,
    atl: ""
  })))), react_1.default.createElement("div", {
    className: "faq-tab-content ".concat(active ? 'tab-content-display' : 'tab-content-hidden', " leading-normal ").concat(className === null || className === void 0 ? void 0 : className.contentWrapper)
  }, react_1.default.createElement("p", {
    className: "pt-1 pb-3 md-1:pl-5 md-1:pr-5 font-16px content text-sm ".concat(className === null || className === void 0 ? void 0 : className.content)
  }, content)));
}

exports.Template3FaqItem = Template3FaqItem;
Template3FaqItem.propTypes = {
  title: prop_types_1.default.string,
  content: prop_types_1.default.string,
  active: prop_types_1.default.bool,
  borderTop: prop_types_1.default.bool,
  className: prop_types_1.default.object
};
Template3FaqItem.defaultProps = {
  title: 'FAQ Text',
  content: 'Sample Text',
  active: false,
  index: 0,
  borderTop: true,
  handleState: function handleState() {},
  className: {
    title: '',
    contentWrapper: '',
    icon: '',
    content: ''
  }
};